
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateNotesDtoFormGroup() {
return new FormGroup({
    notes: new FormControl<string | undefined>('', [Validators.required]),
})
;
}
      